import { API_URL } from '@/constants/common';
import axios from 'axios';
import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
} from '@/lib/utils/auth';

import { refreshAccessToken } from './account';

export const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const accessToken = getAccessToken();

  if (accessToken && !config.headers['Authorization'])
    config.headers['Authorization'] = `Bearer ${accessToken}`;

  return config;
});

let isResponseRetried = false;

axiosInstance.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    const config = error?.config;
    const isLoginPage = window.location.href.includes('login');
    const isResetPasswordPage = window.location.href.includes('reset-password');

    if (
      error?.response?.status === 401 &&
      !isResponseRetried &&
      !isLoginPage &&
      !isResetPasswordPage
    ) {
      const refreshToken = getRefreshToken();
      if (!refreshToken) {
        window.location.href = '/login';
        return Promise.reject(error);
      }

      try {
        isResponseRetried = true;
        const response = await refreshAccessToken(refreshToken);
        const newAccessToken = response.data.token;
        const newAccessTokenExpires = response.data.token_expires;

        setAccessToken(newAccessToken, newAccessTokenExpires);
        config.headers.Authorization = `Bearer ${newAccessToken}`;
        isResponseRetried = false;

        return axiosInstance(config);
      } catch (refreshError) {
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
